import { render } from "./side_bar.vue?vue&type=template&id=38eb6212&scoped=true"
import script from "./side_bar.vue?vue&type=script&lang=js"
export * from "./side_bar.vue?vue&type=script&lang=js"

import "./side_bar.vue?vue&type=style&index=0&id=38eb6212&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38eb6212"]])

export default __exports__